import { Button } from './UI-CHAKRA/Button';
import { Flex } from './UI-CHAKRA/Flex';
import { Text } from './UI-CHAKRA/Text';
import { ReactComponent as ErrorIcon } from '../assets/images/icons/mevo/error.svg';

interface CanceledPrescriptionProps {
  onConfirm?(): void;
  showConfirmButton?: boolean;
}

export function CanceledPrescription(props: CanceledPrescriptionProps) {
  return (
    <Flex h={'100%'} w={'100%'} justifyContent={'center'} alignItems={'center'}>
      <Flex
        bg={'white'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        w={{ base: '100%', md: '410px' }}
        h={props.showConfirmButton ? '272px' : '200px'}
        borderRadius={'20px'}
        p={'24px'}
      >
        <Flex justifyContent={'center'} mb={'15px'}>
          <ErrorIcon />
        </Flex>

        <Text fontSize={'18px'} fontWeight={700} lineHeight={'18px'} textAlign={'center'} mb={'10px'}>
          Receita cancelada
        </Text>
        <Text fontSize={'14px'} fontWeight={400} lineHeight={'16.8px'} textAlign={'center'}>
          Esta página já pode ser fechada.
          {props.showConfirmButton && (
            <>
              <br />
              Clique em continuar para fechar a prescrição.
            </>
          )}
        </Text>

        {props.showConfirmButton && (
          <Flex justifyContent={'center'} mt={'15px'}>
            <Button variant={'outline'} borderRadius={'40px'} onClick={props.onConfirm}>
              Ok, continuar
            </Button>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
